import { useContext } from 'react';
import { PageDataContext } from 'components/Contexts';
const usePageData = () => {
    const { pageData } = useContext(PageDataContext);
    const latestBatch = (pageData === null || pageData === void 0 ? void 0 : pageData.latestBatchTracingDate) && (pageData === null || pageData === void 0 ? void 0 : pageData.latestTraceableRawMaterials)
        ? {
            date: pageData.latestBatchTracingDate,
            rawMaterials: pageData.latestTraceableRawMaterials,
        }
        : undefined;
    return Object.assign(Object.assign({}, pageData), { latestBatch });
};
export default usePageData;
